import { GraphQLResult } from "@aws-amplify/api-graphql";
import { ListBoothBoatTypesQuery } from "API";
import { API, graphqlOperation } from "aws-amplify";
import Select from "components/atoms/CmSelect";
import { listBoothBoatTypes } from "graphql/queries";
import * as React from "react";

type Props = {
  value: string;
  // value: any;
  onChange: any;
};

type Options = {
  name?: string;
  value?: string;
};

export default function CmsSelectBoatType(props: Props) {
  const { value, onChange } = props;
  const [options, setOptions] = React.useState<Options[]>([]);
  async function getBrand() {
    const res = (await API.graphql(
      graphqlOperation(listBoothBoatTypes),
      {}
    )) as GraphQLResult<ListBoothBoatTypesQuery>;
    const brands = res?.data?.listBoothBoatTypes?.items;
    if (brands && brands?.length > 0) {
      const options = brands.map((item) => {
        return { name: item?.name, value: item?.name };
      });
      setOptions(options);
    }
  }

  React.useEffect(() => {
    getBrand();
  }, []);

  return <Select value={value} options={options} onChange={onChange} />;
}
